export const openai_key = 'Bearer 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'
